import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import General from './Settings/General';
import Seo from './Settings/Seo';
import Mail from './Settings/Mail';
import Sms from './Settings/Sms';

interface Props {
  activeSubTab?: string;
}

const SettingsPage: React.FC<Props> = ({ activeSubTab }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentTab = activeSubTab || 'general';

  const adminPath = location.pathname.split('/')[1];

  const renderContent = () => {
    switch (currentTab) {
      case 'seo':
        return <Seo />;
      case 'mail':
        return <Mail />;
      case 'sms':
        return <Sms />;
      case 'general':
      default:
        return <General />;
    }
  };

  return (
    <div className="animate-fade-in">
      <div className="bg-mystic-box border-b border-gray-800">
        <nav className="flex items-center gap-2 p-2 px-6">
          <button 
            onClick={() => navigate(`/${adminPath}/settings`)}
            className={`px-4 py-1.5 text-sm rounded transition-colors ${currentTab === 'general' ? 'bg-mystic-accent text-black font-bold' : 'text-gray-400 hover:bg-gray-800 hover:text-white'}`}
          >
            General
          </button>
          <button 
            onClick={() => navigate(`/${adminPath}/settings/seo`)}
            className={`px-4 py-1.5 text-sm rounded transition-colors ${currentTab === 'seo' ? 'bg-mystic-accent text-black font-bold' : 'text-gray-400 hover:bg-gray-800 hover:text-white'}`}
          >
            SEO
          </button>
          <button 
            onClick={() => navigate(`/${adminPath}/settings/mail`)}
            className={`px-4 py-1.5 text-sm rounded transition-colors ${currentTab === 'mail' ? 'bg-mystic-accent text-black font-bold' : 'text-gray-400 hover:bg-gray-800 hover:text-white'}`}
          >
            Mail
          </button>
          <button 
            onClick={() => navigate(`/${adminPath}/settings/sms`)}
            className={`px-4 py-1.5 text-sm rounded transition-colors ${currentTab === 'sms' ? 'bg-mystic-accent text-black font-bold' : 'text-gray-400 hover:bg-gray-800 hover:text-white'}`}
          >
            SMS
          </button>
        </nav>
      </div>
      
      <div className="p-6">
        {renderContent()}
      </div>
    </div>
  );
};

export default SettingsPage;